import { render, staticRenderFns } from "./ListComment.vue?vue&type=template&id=b3830b12&"
import script from "./ListComment.vue?vue&type=script&lang=js&"
export * from "./ListComment.vue?vue&type=script&lang=js&"
import style0 from "./ListComment.vue?vue&type=style&index=0&id=b3830b12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports